<!--
 * @Author:
 * @LastEditTime: 2025-05-27 18:13:36
 * @Description: zhouhuan
-->
<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-t-10px m-b-5px">模型树</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>

    <div class="height-38 p-5px mt-10px">
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <el-button
          slot="append"
          icon="el-icon-arrow-down"
          class="p-l-10px p-r-10px"
          @click="filterModelTree(modelTreeProp.currentNodeItem, true, filterTreeKeyWords, 0)"
        ></el-button>
        <el-button
          slot="append"
          icon="el-icon-arrow-up"
          class="p-l-10px p-r-10px"
          @click="filterModelTree(modelTreeProp.currentNodeItem, false, filterTreeKeyWords, 0)"
        ></el-button>
      </el-input>
    </div>
    <div
      class="w-full h-[calc(100%-70px)] overflow-hidden mt-10px"
      v-loading="!modelTreeProp.modelTreeLoadEnd"
    >
      <el-tree
        class="modelTree text-white"
        v-if="modelTreeVisbile && modelTreeProp.modelTreeLoadEnd"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="item"
      ></el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelTree',
  props: {
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
        }
      },
    },
    player: {
      type: Object,
      default: null,
    },
    height: {
      type: String,
      default: '50rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
  },
  watch: {
    'modelTreeProp.currentNodeName': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
    'modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
  },
  created() {
    if (this.modelTreeProp.currentNodeName) {
      // 页面初始化时不定位模型
      this.filterModelTree(0, true, this.modelTreeProp.currentNodeName, 0, false)
    }
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
    }
  },
  methods: {
    closeComponents() {
      this.$emit('closeComponents', 'ModelTree')
    },
    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (doLocation) {
        this.$emit('clickModelTree', data, node)
      }
      this.locationNode(data.item)
    },
    // 模型树加载
    async loadNode(node, resolve) {
      console.log(node, 'tree___________')
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.item
        })
        return resolve(this.modelTreeProp.treeData)
      }
      const res = await PlayerUtils.call(this.player.Native.ModelTree.getSubItems, node.data.item)
      console.log(res, '_________PlayerSubs')
      const filterRes = _.filter(res, (el) => {
        return el.name && el.visible
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.item
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.checked
        }),
        (res5) => {
          return res5.item
        }
      )
      // 查看当前节点是否没有在影藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = function(nodeObj) {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.item
            }),
            nodeObj.data.item
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在影藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在影藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在影藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在影藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          if (_.some(filterRes, { checked: false })) {
            this.modelTreeProp.defaultCheckedKey = [
              ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
                return val !== node.data.item
              }),
              ...checkedKeys,
            ]
          }
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
        console.log('在这儿通过三维返回的设置显影')
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.item) {
          if (el.item === this.currentNode.item) {
            this.locationNode(this.currentNode.item)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('modelTree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 800)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      console.log(data, checkeds)
      const isChecked = _.includes(checkeds.checkedKeys, data.item)
      this.$emit('setModelVisible', 'checkModelTree', isChecked, data, checkeds)
    },
    async filterModelTree(startItem, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      this.currentNode = await PlayerUtils.call(
        this.player.Native.ModelTree.findItemByName,
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      console.log(node, 'expendNode______')
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: this.currentNode.checked }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          node.parentItem
        )
        await this.expendNode(res)
        // 展开
        this.defaultExpandedKeys.push(res.item)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
  },
}
</script>

<style lang="scss" scoped>

@import '../css/component.scss';

/deep/.el-card {
  &__header {
    background: none !important;
  }
  &__body {
    padding: 0 !important;
    height: calc(100% - 25px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(53, 52, 52, 0);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #2b323a;
}
/deep/ .el-loading-mask {
  height: calc(100% - 42px);
  background-color: rgba(24, 41, 72, 0.8) !important;
}
.text-color-white {
  color: white;
}
/deep/ .el-input-group__append button.el-button {
  padding-left: 15px;
  padding-right: 15px;
  background: transparent !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px !important;
}
/deep/ .el-input-group__append {
  padding: 0;
}
/deep/ .el-checkbox {
  margin-bottom: 0 !important;
}
.height-38 {
  height: 38px;
}
/deep/ .el-tree-node__label {
  color: white;
}
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.p-l-10px {
  padding-left: 10px;
}
.p-r-10px {
  padding-right: 10px;
}
.fz-14px {
  font-size: 14px;
}
.fz-12px {
  font-size: 12px;
}

</style>
